import { TextField, InputAdornment, IconButton } from "@mui/material";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const FormTextInput = ({
  formik,
  name,
  label,
  placeholder,
  isDisabled,
  type = "text",
  InputProps,
  ...textInputProps
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";
  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  const error = formik.touched[name] && Boolean(formik.errors[name]);

  return (
    <TextField
      fullWidth
      size="small"
      name={name}
      label={label}
      placeholder={placeholder}
      type={inputType}
      value={formik.values[name] ?? ""}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      disabled={isDisabled}
      error={error}
      helperText={formik.touched[name] && formik.errors[name]}
      {...textInputProps}
      InputProps={{
        ...InputProps,
        // The password toggle owns endAdornment when type="password";
        // otherwise a caller-supplied one passes through untouched.
        endAdornment: isPassword ? (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
              disabled={isDisabled}
            >
              {showPassword ? (
                <VisibilityOff fontSize="small" />
              ) : (
                <Visibility fontSize="small" />
              )}
            </IconButton>
          </InputAdornment>
        ) : (
          InputProps?.endAdornment
        ),
      }}
    />
  );
};